export default class CompanyBanList {

	constructor (data) {
		this.data = data

		// Build id index
		this.index = {}
		for (let entry of this.data) {
			this.index[entry.id] = entry
		}

		// Build ban index
		this.ban_index = {}
		for (let entry of this.data) {
			this.ban_index[entry.ban] = entry
		}
	}

	static async fetch () {

		let data = await Anvil.REST.get('/company_ban')

		return new CompanyBanList(data)
	}

	getById (id) {
		return this.index[id]
	}

	getByBan (ban) {
		return this.ban_index[ban]
	}
}
